import React from "react";
import BreadCrumbsCompoent from "./breadcrumbs.component";
import { IBreadcrumbs } from "./types";

const BradCrumbsContainer = ({ breadcrumbsData = [] }: IBreadcrumbs) => {
  return <BreadCrumbsCompoent breadcrumbsData={breadcrumbsData} />;
};

export default BradCrumbsContainer;
